import { isUndefined } from 'underscore';
import { FORMS_ONBOARDING_USER_ATTRIBUTE, FORMS_ABM_ONBOARDING_USER_ATTRIBUTE, FORMS_COMMENTING_USER_ATTRIBUTE, FORMS_PAYMENT_BOOTSTRAPPER_USER_ATTRIBUTE } from 'FormsUI/constants/UserAttributes';
function getUserAttributes(state) {
  return state.userAttributes;
}
export function getAttribute(state, key) {
  return getUserAttributes(state).get(key);
}
const isUserAttributeTrue = (state, userAttribute) => {
  const attribute = getAttribute(state, userAttribute);
  return isUndefined(attribute) || attribute === 'true';
};
export const isUserOnboarded = state => isUserAttributeTrue(state, FORMS_ONBOARDING_USER_ATTRIBUTE);
export const isUserOnboardedForAbm = state => isUserAttributeTrue(state, FORMS_ABM_ONBOARDING_USER_ATTRIBUTE);
export const isUserOnboardedForCommenting = state => {
  return isUserAttributeTrue(state, FORMS_COMMENTING_USER_ATTRIBUTE);
};
export const isUserOnboardedForPaymentBootstrap = state => isUserAttributeTrue(state, FORMS_PAYMENT_BOOTSTRAPPER_USER_ATTRIBUTE);